import {
  LeadSequenceReturnReadable,
  leadsLogsListQueryKey,
  leadsSequencesListQueryKey,
  leadsSequencesPartialUpdateMutation
} from '@crm/api'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { useLocales } from '@shared/locales'
import { showApiErrors } from '@shared/utils'
import { useMutation } from '@tanstack/react-query'
import { App, Button, Dropdown } from 'antd'
import { MenuProps } from 'antd/lib'
import { ArrowDown2 } from 'iconsax-react'

type Props = {
  leadId: string
  sequence: LeadSequenceReturnReadable
  bordered?: boolean
  block?: boolean
}

export const CampaignSteps = ({ leadId, sequence, block, bordered }: Props) => {
  const { t } = useLocales()
  const { invalidateQueries } = useInvalidatePredicateQueries()

  const { notification } = App.useApp()

  const { mutate, isPending } = useMutation({
    ...leadsSequencesPartialUpdateMutation(),
    onError: (error) => showApiErrors(error),
    onSuccess: () => {
      invalidateQueries([
        leadsLogsListQueryKey({ path: { lead_id: leadId } }),
        leadsSequencesListQueryKey({ path: { lead_id: leadId } })
      ])

      notification.success({
        message: t('success.success'),
        description: t('success.success_data_save')
      })
    }
  })

  const onClickDropdownItems = (currentStep?: string) => {
    if (!sequence.sequence.id) return

    mutate({
      path: { lead_id: leadId, sequence: sequence.sequence.id },
      body: {
        current_step: currentStep ? Number(currentStep) : null
      }
    })
  }

  const items: MenuProps['items'] = sequence?.sequence?.steps?.map(
    ({ title, id }) => ({ label: title, key: String(id) })
  )

  if (!items?.length) return null

  return (
    <Dropdown
      trigger={['click']}
      menu={{
        items,
        selectedKeys: sequence?.current_step?.id
          ? [String(sequence?.current_step?.id)]
          : [],
        onClick: ({ key }) => onClickDropdownItems(key)
      }}
    >
      <Button
        loading={isPending}
        icon={<ArrowDown2 size={16} variant="Bold" />}
        iconPosition="end"
        type={bordered ? 'default' : 'text'}
        block={block}
      >
        {sequence?.current_step?.title}
      </Button>
    </Dropdown>
  )
}
